import { Link, NativeLink, DisabledLink } from "./styles";

interface LinkProps {
  href: string;
  options: {
    type: "filled" | "outline" | "link";
    size: "sm" | "md" | "lg" | "xl";
    skin: "purple" | "transparent";
    block?: boolean;
    native?: boolean;
  };
  target?: string;
  children: any;
  disabled?: boolean;
  noFollow?: boolean;
  styles?;
}

const Component = ({
  href,
  disabled,
  target,
  options,
  children,
  ...rest
}: LinkProps) => {
  const { native = true, block } = options;

  if (disabled) {
    return (
      <DisabledLink {...options} {...rest} block={block}>
        {children}
      </DisabledLink>
    );
  }

  if (native) {
    return (
      <NativeLink
        to={href}
        {...options}
        {...rest}
        target={target}
        block={block}
      >
        {children}
      </NativeLink>
    );
  }

  return (
    <Link href={href} {...options} {...rest} target={target} block={block}>
      {children}
    </Link>
  );
};

export default Component;
